const listSelector = ({ list }) => list.list;

export default listSelector;
